import { Enum } from "./Enum";

export const ElasticSearchEnum: Enum[] = [
    { id: "all", name: "All" },
    { id: "page", name: "Page" },
    { id: "article", name: "Article" },
    { id: "product", name: "Product" },
]